import React from 'react';
import { Button, TwIconButton } from 'components/common';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaFileImport } from 'react-icons/fa';
import { RiShip2Fill } from 'react-icons/ri';
const JobHeader = ({ onImport }) => {
  const navigate = useNavigate();

  return (
    <div className="tw-mb-1">
      <div className="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-3">
        <div className="tw-flex tw-items-center tw-gap-3">
          <TwIconButton
            icon={FaArrowLeft}
            iconSize={14}
            variant="secondary"
            size="lg"
            onClick={() => navigate(-1)}
            title="Back"
          />

          <div className="tw-w-1.5 tw-h-10 tw-rounded-sm tw-flex-shrink-0" style={{ background: 'linear-gradient(to bottom, #0ea5e9, #6366f1)' }} />

          <div className="tw-flex tw-items-center tw-gap-2">
            <RiShip2Fill className="tw-text-sky-500" size={22} />
            <div>
              <h1 className="tw-mb-0 tw-font-bold tw-text-2xl tw-text-gray-900">Shipment for Jobs</h1>
              <p className="tw-text-gray-500 tw-text-sm tw-mb-0">Track VTF / OS weight and packing lists per job across the selected period.</p>
            </div>
          </div>
        </div>

        {onImport && (
          <div className="tw-flex tw-items-center tw-gap-2">
            <Button
              variant="secondary"
              size="md"
              leftIcon={FaFileImport}
              onClick={onImport}
              title="Import packing list"
              className="tw-bg-amber-50 tw-text-amber-700 tw-border-amber-300 hover:tw-bg-amber-100"
            >
              Import Packing List
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

JobHeader.propTypes = {
  onImport: PropTypes.func,
};

export default JobHeader;
